class EventHandlerClass {
    constructor() {
        this.functionMap = {};
    }

    addEventListener(event, func, element = document) {
        this.functionMap[event] = func;

        if (element === "document") {
            document.addEventListener(
                event.split(".")[0],
                this.functionMap[event]
            );
        } else if (element === "body") {
            document
                .querySelector("body")
                .addEventListener(event.split(".")[0], this.functionMap[event]);
        } else {
            window.addEventListener(
                event.split(".")[0],
                this.functionMap[event]
            );
        }
    }

    removeEventListener(event, element = document) {
        if (element === "document") {
            document.removeEventListener(
                event.split(".")[0],
                this.functionMap[event]
            );
        } else if (element === "body") {
            document
                .querySelector("body")
                .removeEventListener(
                    event.split(".")[0],
                    this.functionMap[event]
                );
        } else {
            window.removeEventListener(
                event.split(".")[0],
                this.functionMap[event]
            );
        }

        delete this.functionMap[event];
    }
}

export const EventHandler = new EventHandlerClass();
